import * as types from "./types";

export const getAdminDashboardOverviewRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_OVERVIEW_REQUEST,
});

export const getAdminDashboardOverviewResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_OVERVIEW_RESPONSE,
  payload,
});

export const getAdminDashboardQuickActionsRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_QUICK_ACTIONS_REQUEST,
});

export const getAdminDashboardQuickActionsResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_QUICK_ACTIONS_RESPONSE,
  payload,
});

export const getAdminDashboardTopCompaniesRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_TOP_COMPANIES_REQUEST,
});

export const getAdminDashboardTopCompaniesResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_TOP_COMPANIES_RESPONSE,
  payload,
});

export const getAdminDashboardOverviewFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_OVERVIEW_FAILURE,
});

export const getAdminDashboardQuickActionsFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_QUICK_ACTIONS_FAILURE,
});

export const getAdminDashboardTopCompaniesFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_TOP_COMPANIES_FAILURE,
});

export const getAdminDashboardTopEventsRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_TOP_EVENTS_REQUEST,
});

export const getAdminDashboardTopEventsResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_TOP_EVENTS_RESPONSE,
  payload,
});

export const getAdminDashboardTopEventsFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_TOP_EVENTS_FAILURE,
});

export const getAdminDashboardCompanySatisfactionRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_REQUEST,
});

export const getAdminDashboardCompanySatisfactionResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_RESPONSE,
  payload,
});

export const getAdminDashboardCompanySatisfactionFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_COMPANY_SATISFACTION_FAILURE,
});

export const getAdminDashboardApplicantEngagementRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_REQUEST,
});

export const getAdminDashboardApplicantEngagementResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_RESPONSE,
  payload,
});

export const getAdminDashboardApplicantEngagementFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_APPLICANT_ENGAGEMENT_FAILURE,
});

export const getAdminDashboardRecentActivityRequest = () => ({
  type: types.GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_REQUEST,
});

export const getAdminDashboardRecentActivityResponse = (payload) => ({
  type: types.GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_RESPONSE,
  payload,
});

export const getAdminDashboardRecentActivityFailure = () => ({
  type: types.GET_ADMIN_DASHBOARD_RECENT_ACTIVITY_FAILURE,
});
